import { render } from "./UserEnterpriseProfile.vue?vue&type=template&id=872fddd4&scoped=true&ts=true"
import script from "./UserEnterpriseProfile.ts?vue&type=script&lang=ts"
export * from "./UserEnterpriseProfile.ts?vue&type=script&lang=ts"

import "./UserEnterpriseProfile.scss?vue&type=style&index=0&id=872fddd4&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-872fddd4"]])

export default __exports__